import {createReducer} from "redux-act";
import {
	IFetchVotesResponse,
	IReducerAction,
	ISaveVotesResponse,
	IVoteReducer,
	IWithLanguage,
} from "modules/types";
import {RequestStateType} from "modules/enums";
import {
	addFanVotePlayer,
	closeFanVoteSavedModal,
	fetchFanVotes,
	fetchFanVotesFailed,
	fetchFanVotesSuccess,
	fetchFavVoteSharingImage,
	fetchFavVoteSharingImageFailed,
	fetchFavVoteSharingImageSuccess,
	removeFanVotePlayer,
	saveFanVotePlayer,
	saveFanVotePlayerFailed,
	saveFanVotePlayerSuccess,
	setFanVoteHasChanged,
} from "modules/actions";

const initialState: IVoteReducer = {
	fetchRequestState: RequestStateType.Idle,
	saveRequestState: RequestStateType.Idle,
	playerId: null,
	history: [],
	shareImage: "",
	shareImageRequestState: RequestStateType.Idle,
	hasChanged: false,
};

type IVoteReducerPayload<TP = null> = IReducerAction<IVoteReducer, TP>;

const onFetchVotes: IVoteReducerPayload<boolean> = (state: IVoteReducer) => ({
	...state,
	fetchRequestState: RequestStateType.Loading,
});

const onFetchVotesSuccess: IVoteReducerPayload<IFetchVotesResponse> = (
	state: IVoteReducer,
	payload
) => ({
	...state,
	fetchRequestState: RequestStateType.Success,
	history: payload.history,
});

const onFetchVotesFailed: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	fetchRequestState: RequestStateType.Error,
});

const onAddFanVotePlayer: IVoteReducerPayload<number> = (state: IVoteReducer, payload) => ({
	...state,
	playerId: payload,
});

const onRemoveFanVotePlayer: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	playerId: null,
});

const onSaveFanVotePlayer: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	saveRequestState: RequestStateType.Loading,
});

const onSaveFanVotePlayerSuccess: IVoteReducerPayload<ISaveVotesResponse> = (
	state: IVoteReducer,
	payload
) => ({
	...state,
	saveRequestState: RequestStateType.Success,
	history: payload.history,
	playerId: null,
});

const onSaveFanVotePlayerFailed: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	saveRequestState: RequestStateType.Error,
});

const onFetchFavVoteSharingImage: IVoteReducerPayload<IWithLanguage<number>> = (
	state: IVoteReducer
) => ({
	...state,
	shareImageRequestState: RequestStateType.Loading,
});

const onFetchFavVoteSharingImageSuccess: IVoteReducerPayload<string> = (
	state: IVoteReducer,
	payload
) => ({
	...state,
	shareImage: payload,
	shareImageRequestState: RequestStateType.Success,
});

const onFetchFavVoteSharingImageFailed: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	shareImageRequestState: RequestStateType.Error,
});

const onCloseFanVoteSavedModal: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	shareImage: "",
	shareImageRequestState: RequestStateType.Idle,
});

const onSetFanVoteHasChanged: IVoteReducerPayload = (state: IVoteReducer) => ({
	...state,
	hasChanged: true,
});

export const fanVoteReducer = createReducer({}, initialState)
	.on(fetchFanVotes, onFetchVotes)
	.on(fetchFanVotesSuccess, onFetchVotesSuccess)
	.on(fetchFanVotesFailed, onFetchVotesFailed)
	.on(addFanVotePlayer, onAddFanVotePlayer)
	.on(removeFanVotePlayer, onRemoveFanVotePlayer)
	.on(saveFanVotePlayer, onSaveFanVotePlayer)
	.on(saveFanVotePlayerSuccess, onSaveFanVotePlayerSuccess)
	.on(saveFanVotePlayerFailed, onSaveFanVotePlayerFailed)
	.on(fetchFavVoteSharingImage, onFetchFavVoteSharingImage)
	.on(fetchFavVoteSharingImageSuccess, onFetchFavVoteSharingImageSuccess)
	.on(fetchFavVoteSharingImageFailed, onFetchFavVoteSharingImageFailed)
	.on(closeFanVoteSavedModal, onCloseFanVoteSavedModal)
	.on(setFanVoteHasChanged, onSetFanVoteHasChanged);
